import React from 'react';
import Link from 'next/link';

import Icon from '../../../Icon';

/**
 * Widget List Props
 */

type WidgetListProps = {
  items: {
    label: string;
    href: string;
  }[];
};

/**
 * Widget List Component
 */

export default function WidgetList({ items }: WidgetListProps) {
  return (
    <div className="flex flex-col gap-4 px-4 py-4">
      {items.map((item) => (
        <div className="flex items-start gap-2" key={item.label}>
          <Icon iconName="Article" size="IconS" className="bg-site-accent-600 translate-y-1" />

          <Link href={item.href} className="site-paragraph-s text-site-neutrals-600 font-normal hover:underline">
            {item.label}
          </Link>
        </div>
      ))}
    </div>
  );
}
